import React, { useEffect } from 'react';

const XeroCallback = () => {
  useEffect(() => {
    // Extract the authorization code from URL
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    if (error) {
      // Send error to parent window
      if (window.opener) {
        window.opener.postMessage({
          type: 'XERO_AUTH_ERROR',
          error: error
        }, window.location.origin);
      }
      window.close();
    } else if (code) {
      // Send success with code to parent window
      if (window.opener) {
        window.opener.postMessage({
          type: 'XERO_AUTH_SUCCESS',
          code: code
        }, window.location.origin);
      }
      // Don't close window here - let parent close it
    }
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-800 mb-2">Processing Authorization</h2>
        <p className="text-gray-600">Please wait while we complete the connection to Xero...</p>
      </div>
    </div>
  );
};

export default XeroCallback;
